const MISSING_VEHICLE_VALUES = new Set([
  "",
  "-",
  "n/a",
  "na",
  "nil",
  "none",
  "null",
  "undefined",
  "unknown",
]);

const getUsableValue = (...values) => {
  for (const value of values) {
    if (value === null || value === undefined) continue;

    const normalizedValue = String(value).trim();
    if (!MISSING_VEHICLE_VALUES.has(normalizedValue.toLowerCase())) {
      return normalizedValue;
    }
  }

  return "";
};

const getAutoRegPayload = (response) => {
  if (!response || typeof response !== "object") return {};

  return response?.data?.data || response?.data || response;
};

const resolveField = (primaryValues, autoRegValues) => {
  const primaryValue = getUsableValue(...primaryValues);
  if (primaryValue) {
    return { value: primaryValue, source: "fast-policy" };
  }

  const autoRegValue = getUsableValue(...autoRegValues);
  if (autoRegValue) {
    return { value: autoRegValue, source: "autoreg" };
  }

  return { value: "", source: "" };
};

export const mergeVehicleInfo = (fastPolicyData, autoRegResponse) => {
  const primary = fastPolicyData || {};
  const autoReg = getAutoRegPayload(autoRegResponse);

  const year = resolveField(
    [primary.year_of_make, primary.year, primary.vehicle_year],
    [
      autoReg.vehicle_year,
      autoReg.year_of_make,
      autoReg.manufacture_year,
      autoReg.model_year,
      autoReg.year,
    ],
  );
  const make = resolveField(
    [
      primary.vehicle_make_custom,
      primary.make,
      primary.vehicleMake,
      primary.vehicle_type,
      primary.vehicle_make,
    ],
    [autoReg.vehicle_make, autoReg.make, autoReg.vehicleMake],
  );
  const model = resolveField(
    [
      primary.vehicle_model_custom,
      primary.model,
      primary.vehicleModel,
      primary.vehicle_model,
    ],
    [autoReg.vehicle_model, autoReg.model, autoReg.vehicleModel],
  );
  const color = resolveField(
    [
      primary.color,
      primary.vehicle_color,
      primary.vehicle_colour,
      primary.vehicleColor,
    ],
    [
      autoReg.vehicle_color,
      autoReg.vehicle_colour,
      autoReg.color,
      autoReg.vehicleColor,
    ],
  );
  const chassis = resolveField(
    [
      primary.chasis_no,
      primary.chassis_no,
      primary.chassis,
      primary.chassisNumber,
    ],
    [
      autoReg.chassis,
      autoReg.chassis_no,
      autoReg.chasis_no,
      autoReg.chassisNumber,
    ],
  );

  return {
    year: year.value,
    make: make.value,
    model: model.value,
    color: color.value,
    chassis: chassis.value,
    sources: {
      year: year.source,
      make: make.source,
      model: model.source,
      color: color.source,
      chassis: chassis.source,
    },
  };
};

export const hasVehicleInfo = (vehicleInfo) =>
  Boolean(
    vehicleInfo?.year ||
      vehicleInfo?.make ||
      vehicleInfo?.model ||
      vehicleInfo?.color ||
      vehicleInfo?.chassis,
  );

